import Count from './Count';
import { default as Core } from './filterChip';
import Icon from './Icon';
import Label from './Label';

const FilterChip = Object.assign(Core, { Icon, Label, Count });

export default FilterChip;
